

module.exports = __webpack_require__.stylable.create(
    "Tab3322986854",
    {"classes":{"root":"Tab3322986854__root","focusIndicatorWrapper":"Tab3322986854__focusIndicatorWrapper","focusIndicator":"Tab3322986854__focusIndicator","tabContentWrapper":"Tab3322986854__tabContentWrapper","prefix":"Tab3322986854__prefix"},"vars":{},"stVars":{"activeIndicatorColor":"color-8","focusIndicatorColor":"color-8"},"keyframes":{}},
    "",
    1,
    "Tab3322986854",
    null
);
